var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncentivos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg36",
    width: 48.02,
    height: 37.674,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs20"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style18"
  }, ".cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2",
    transform: "translate(-10.31 .001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1",
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.31 11.52A10.45 10.45 0 0 1 11 9.81 3.92 3.92 0 0 1 14.33 8c5.89-.24 11.79-.45 17.68-.7a3 3 0 0 0 1.24-.34c2.57-1.36 5.12-2.75 7.69-4.11a.6.6 0 0 0 .37-.61A2.07 2.07 0 0 1 43.44 0h1.08a2.07 2.07 0 0 1 2 2.15v6.52a.72.72 0 0 0 .43.72A7.28 7.28 0 0 1 50.78 16a7.28 7.28 0 0 1-3.84 6.55.68.68 0 0 0-.39.69v6.39a2.12 2.12 0 0 1-2.3 2.37 7.6 7.6 0 0 1-1.17 0 2 2 0 0 1-1.76-2 .76.76 0 0 0-.49-.78q-3.67-1.94-7.31-3.93a3.3 3.3 0 0 0-1.73-.48h-1.55a3.94 3.94 0 0 1-4.05 3.63v7.1A2.08 2.08 0 0 1 24 37.67h-1.69a2.07 2.07 0 0 1-2.17-2.15v-2.11c0-.54.3-.86.73-.85.43.01.67.32.68.85.01.53 0 1.35 0 2 0 .65.22.82.82.84.6.02 1.13 0 1.69 0s.73-.25.73-.73V24.58a1.08 1.08 0 0 0 0-.17l-5.56-.22c.12.18.19.31.28.43.6.82 1.21 1.64 1.78 2.48a1.77 1.77 0 0 1 .28.86v2.16c0 .53-.27.82-.7.82-.43 0-.69-.3-.71-.82a1 1 0 0 1 0-.19 4.19 4.19 0 0 0-1.17-3.63 16.39 16.39 0 0 1-1.33-1.82.8.8 0 0 0-.73-.4c-.86 0-1.72-.06-2.58-.09a4.15 4.15 0 0 1-3.91-3.27c0-.11-.06-.21-.1-.31zM23.94 23h.48c2.7.11 5.41.21 8.11.34a2.6 2.6 0 0 1 1.06.29c2.43 1.29 4.85 2.6 7.27 3.9l.4.2V4.24l-.42.21C38.45 5.74 36.06 7 33.66 8.31a3 3 0 0 1-1.19.34c-2 .1-3.94.16-5.91.24L23.94 9v2.33a.69.69 0 0 1-1.33.19 1.52 1.52 0 0 1-.07-.51v-1.9h-1.68v13.76h1.67v-8.1a3.15 3.15 0 0 1 0-.61.7.7 0 0 1 1.38.07V23ZM19.4 9.2h-.17c-1.67.06-3.35.1-5 .21a2.65 2.65 0 0 0-2.48 2.56q-.06 4 0 8.07a2.68 2.68 0 0 0 2.55 2.59c1.53.08 3.06.13 4.59.19h.51ZM42.71 16v13.22c0 1.27.07 1.34 1.36 1.34.9 0 1.08-.18 1.08-1.07V2.83c0-1.36-.06-1.42-1.43-1.41-.81 0-1 .19-1 1v13.57m3.89-5.16v10.34a6.11 6.11 0 0 0 2.77-5.6 6 6 0 0 0-2.77-4.76m-20.39 16a2.3 2.3 0 0 0 2.56-2.26H26.2Z",
    id: "path26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.33 8.91a1.6 1.6 0 0 1-.36.46c-.77.51-1.55 1-2.34 1.45a.68.68 0 0 1-1-.2.7.7 0 0 1 .27-1c.76-.48 1.53-1 2.3-1.42.53-.31 1.11 0 1.11.72",
    id: "path28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.28 16.69h-1.36a.71.71 0 1 1 0-1.4h2.71a.7.7 0 1 1 0 1.4h-1.36",
    id: "path30",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.72 24a4.61 4.61 0 0 1-.53-.22L53 22.39a.72.72 0 0 1-.32-1 .71.71 0 0 1 1.06-.17c.76.46 1.51.93 2.27 1.4a.64.64 0 0 1 .32.83c-.11.23-.38.39-.56.56",
    id: "path32",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentivos);
export default __webpack_public_path__ + "static/media/incentivos.9ef5ec1162d9d3df150d16c78806cb2e.svg";
export { ForwardRef as ReactComponent };